import Query from './query'
Query.install = (Vue) => {
  Vue.component(Query.name, Query)
}

export default Query


// WEBPACK FOOTER //
// ./src/components/query/index.js